export default "__VITE_ASSET__DyjxiGJn__"